import Axios from "../redux/setupAxios";
import { microserviceNames, Urls } from "../app/utils/constants";
import axios from "axios";

const proxyName = microserviceNames.asanMicroserviceProxy;

export async function sign(body) {
  return (await Axios.post(`${proxyName}/signin/sign`, body)).data;
}

export async function signFiles(body) {
  return (await Axios.post(`${proxyName}/signin/signFiles`, body)).data;
}

export async function checkStatus(body) {
  return (await Axios.post(`${proxyName}/signin/getSignStatus`, body)).data;
}

export async function getBusinessCertificate(body) {
  return (
    await Axios.post(
      `${proxyName}/signin-certificates/getBusinessSigningCertificate`,
      body
    )
  ).data;
}

export async function getSigningCertificates(body) {
  return (
    await Axios.post(
      `${proxyName}/signin-certificates/getSigningCertificates`,
      body
    )
  ).data;
}

// =======EXTERNAL API'S========

export async function checkAsanToken() {
  return (await axios.get(Urls.ASAN_Check_Token, { withCredentials: true }))
    .data;
}

export async function getASANCertificates(token) {
  return (
    await axios.get(Urls.ASAN_Get_Certs, { headers: { Authorization: token } })
  ).data;
}

export async function getSignFileStatus(body) {
  return (await Axios.post(`${proxyName}/signin/getSignFileStatus`, body)).data;
}

export async function getSignEventAppFileStatus(body) {
  return (await Axios.post(`${proxyName}/signin/getSignEventAppFileStatus`, body)).data;
}